import { DerbyQuiz } from '@/widgets/derby-quiz';

// Без Screen/заголовка «Дерби»: в макете (438:51737/438:51717) над кольцом
// только персистентная шапка приложения, отдельного тайтла страницы нет.
export function DerbyPage() {
  return <DerbyQuiz />;
}
